import { type LinearConfigurationDTO } from "~/features/configurator/Linear/dtos";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { loadData } from "~/features/configurator/Linear/redux/actions";
import { ConfiguratorPage } from "~/features/configurator/common/components/ConfiguratorPage";
import {
  getAllConfiguratorDefinitions,
  registerConfiguratorDefinition,
} from "~/bridges/configurator/configuratorRegistry";
import { CARRIAGE_DEFINITION } from "~/features/configurator/Carriage/CarriageConfigurationPage";
import { KWLT_CARRIAGE_DEFINITION } from "~/features/configurator/Carriage/v2/configuration/kwlt/KWLTCarriageConfigurationPage";
import { RAIL_DEFINITION } from "~/features/configurator/Rail/v2/configuration/classic/RailConfigurationPage";
import { LC_DEFINITION } from "~/features/configurator/Linear/v2/configuration/classic/UnitConfiguratorPage";
import { KLLT_UNIT_DEFINITION } from "~/features/configurator/Linear/v2/configuration/kllt/KLLTUnitConfigurationPage";
import { KUEM_UNIT_DEFINITION } from "~/features/configurator/Linear/v2/configuration/kuem/KUEMUnitConfigurationPage";
import { METRIC_SHAFT_DEFINITION } from "~/features/configurator/Shaft/v2/configuration/MetricShaftConfiguratorPage";
import { IMPERIAL_SHAFT_DEFINITION } from "~/features/configurator/Shaft/v2/configuration/ImperialShaftConfiguratorPage";
import { getStore } from "~/app/store/getStore";
import { trackLCStepStarted } from "~/features/configurator/common/configuratorGA";
import { TKDM_RAIL_DEFINITION } from "~/features/configurator/Rail/v2/configuration/tkdm/TKDMRailConfigurationPage";
import { TKLT_RAIL_DEFINITION } from "~/features/configurator/Rail/v2/configuration/tklt/TKLTRailConfigurationPage";
import instance from "~/utils/i18n";
import { XML_TRANSLATION_SHEETS } from "~/features/configurator/common/useXmlConfiguratorTranslations";
import {
  type ConfiguratorPageCustomization,
  ConfiguratorPageCustomizationContext,
} from "~/features/configurator/common/components/ConfiguratorPageCustomizationContext";

export function createConfiguratorPage(props: {
  data: LinearConfigurationDTO;
  helpUrl: string;
  customization: ConfiguratorPageCustomization;
}) {
  const path = window.location.pathname;
  const productCode = path.match(/\d+/)?.[0];
  const configDefinition = getAllConfiguratorDefinitions().find((item) => item.productCode === productCode);
  if (!configDefinition) {
    console.error("No configurator definition available!");
    return null;
  }
  const configuratorType = configDefinition.type;

  const model = transform(props.data, configuratorType);

  getStore().dispatch(loadData(model, props.helpUrl, configuratorType));

  if (model.highestVisitedStep === model.currentStep) {
    const sheetName = XML_TRANSLATION_SHEETS[configuratorType];
    instance.loadNamespaces(sheetName!.sheetName).then(() => {
      // index from model is 1 based, while in state it's 0 based
      trackLCStepStarted(configDefinition.productCode, model.currentStep - 1);
    });
  }

  return (
    <ConfiguratorPageCustomizationContext.Provider value={props.customization}>
      <ConfiguratorPage config={configDefinition} />
    </ConfiguratorPageCustomizationContext.Provider>
  );
}

registerConfiguratorDefinition(CARRIAGE_DEFINITION);
registerConfiguratorDefinition(KWLT_CARRIAGE_DEFINITION);
registerConfiguratorDefinition(RAIL_DEFINITION);
registerConfiguratorDefinition(TKDM_RAIL_DEFINITION);
registerConfiguratorDefinition(TKLT_RAIL_DEFINITION);
registerConfiguratorDefinition(LC_DEFINITION);
registerConfiguratorDefinition(KLLT_UNIT_DEFINITION);
registerConfiguratorDefinition(KUEM_UNIT_DEFINITION);

registerConfiguratorDefinition(METRIC_SHAFT_DEFINITION);
registerConfiguratorDefinition(IMPERIAL_SHAFT_DEFINITION);
